import graphqlClient from '@/graphql/graphql-client';
import { useMutation } from '@tanstack/react-query';

import type { InsertOrgContractSignatureLogMutation, InsertOrgContractSignatureLogMutationVariables } from '@/graphql/generated/graphql';
import { InsertOrgContractSignatureLogDocument } from '@/graphql/generated/graphql';
export type OrgContractSignatureLogInsertInput = {
  OrganizationIds?: string[]
  ContractDocumentId?: string
  InitiatedByUserId?: string
  SigDocumentId?: string
  TrackingId?: string
  Payload?: string
  Status?: string
  ErrorMessages?: string
}

export type InsertOrgContractSignatureLogResponse = {
  data: {
    insertOrgContractSignatureLog: {
      itemId: string
      totalImpactedData: number
      acknowledged: boolean
      message?: string | null
    }
  }
}

export const useInsertOrgContractSignatureLog = () => {
  const mutation = useMutation({
    mutationKey: ['insert-org-contract-signature-log'],
    mutationFn: (variables: OrgContractSignatureLogInsertInput) => {
      return graphqlClient.request<InsertOrgContractSignatureLogMutation>(InsertOrgContractSignatureLogDocument,
        variables
      )
    }
  })

  return {
    ...mutation,
    insertOrgContractSignatureLog: mutation.mutate,
    insertOrgContractSignatureLogAsync: mutation.mutateAsync,
  }
}

export const INSERT_ORG_CONTRACT_SIGNATURE_LOG_MUTATION = InsertOrgContractSignatureLogDocument;
